export const CLIENT_PROPERTY_DAILY_VISIT_LIMIT_MESSAGE =
  "Você já possui 2 visitas agendadas para este imóvel neste dia.";

type ApiErrorShape = {
  response?: {
    status?: number;
    data?: {
      message?: unknown;
      errors?: Record<string, unknown>;
    };
  };
};

function firstValidationError(errors: Record<string, unknown> | undefined): string {
  if (!errors || typeof errors !== "object") return "";

  for (const value of Object.values(errors)) {
    if (Array.isArray(value) && typeof value[0] === "string" && value[0].trim()) {
      return value[0].trim();
    }
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }

  return "";
}

/**
 * Laravel 422 often sends both `message` and `errors.field[]` with the same text.
 * Prefer a single toast title so the daily-visit limit is not shown twice.
 */
export function getApiErrorToastTitle(
  err: unknown,
  fallback = "Erro ao processar a solicitação"
): string {
  const data = (err as ApiErrorShape)?.response?.data;
  const message =
    typeof data?.message === "string" ? data.message.trim() : "";
  if (message) return message;

  const fromErrors = firstValidationError(data?.errors);
  if (fromErrors) return fromErrors;

  return fallback;
}
